import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiClient from "../../../shared/API/apiClient";
import Toast from "../../../shared/components/Toast";
export default function SingleRolesPermissionsPage() {

    const [toast, setToast] = useState(null);

    const navigate = useNavigate();

    const { roleId } = useParams();

    const [loading, setLoading] = useState(true);

    const [role, setRole] = useState({});

    const [modules, setModules] = useState([]);

    useEffect(() => {

        loadPermissions();

    }, []);

// =========================================
  // TOAST
  // =========================================

  const showToast = (
    message,
    type = "success"
  ) => {

    setToast({
      message,
      type
    });
  };
    const loadPermissions = async () => {

    try {

        setLoading(true);

        const response = await apiClient.get(`/api/users/${roleId}/permissions`);

       setRole(response.data.role);

      setModules(response.data.modules);


    } catch (error) {

        console.error(error);

    } finally {

        setLoading(false);

    }

};

    const togglePermission=(parentId,moduleId,permissionId,checked)=>{
  setModules(prev=>prev.map(parent=>parent.parent_id!==parentId?parent:{
    ...parent,
    modules:parent.modules.map(module=>module.module_id!==moduleId?module:{
      ...module,
      permissions:module.permissions.map(permission=>permission.permission_id===permissionId?{...permission,allow_access:checked}:permission)
    })
  }));
};

    const toggleModule = () => {

    };

    const savePermissions = async () => {

    try {

        await apiClient.put(

            `/api/users/${roleId}/permissions`,

            {
                modules
            }

        );
        showToast("Permissions updated successfully.");          // success
       

    } catch (error) {

        console.error(error);
showToast("Failed to save permissions.");          // failed

        alert("Failed to save permissions.");

    }

};
    return (

<div className="page-content">

    {loading ? (

        <div className="chart-card">
            Loading...
        </div>

    ) : (

        <>
<div className="le-page-header">
        <div>
            <div className="dash-page-title">{role.name || ""} Role Details</div>

            <div className="dash-page-subtitle">{role.description || ""}</div>
            </div>
                    <button
                        className="org-btn-cancel"
                        onClick={() => navigate("/dashboard/roles-permissions")}
                    >
                        Back to roles
                    </button>
        </div>
            

            {modules.map(parent => (

                <div key={parent.parent_id} className="chart-card chart-row">

    <div className="chart-header">
        <h4>{parent.parent_name}</h4>
    </div>

    <div className="permission-table-wrapper">

        <div className="permission-table">

            <table>

                <thead>

                    <tr>

                        <th className="sticky-column">
                            Sub Module
                        </th>

                        <th>
                            Permissions
                        </th>

                    </tr>

                </thead>

                <tbody>

                    {parent.modules.map(module => (

                        <tr key={module.module_id}>

                            <td className="sticky-column">
                                {module.module_name}
                            </td>

                            <td>

                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "18px"
                                    }}
                                >

                                    {module.permissions.map(permission => (

                                        <label
                                            key={permission.permission_id}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px"
                                            }}
                                        >

                                            <input
                                                type="checkbox"
                                                
                                                checked={permission.allow_access}
                                                onChange={(e)=>
                                                    togglePermission(
                                                        parent.parent_id,
                                                        module.module_id,
                                                        permission.permission_id,
                                                        e.target.checked
                                                    )
                                                }
                                            />

                                            {permission.permission_name}

                                        </label>

                                    ))}

                                </div>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    </div>

</div>

            ))}

            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 10,
                    marginTop: 20
                }}
            >

                <button
                    className="org-btn-cancel"
                    onClick={() => navigate("/dashboard/roles-permissions")}
                >
                    Cancel
                </button>

                <button
                    className="org-btn-save"
                    onClick={savePermissions}
                >
                    Save Permissions
                </button>

            </div>

        </>

    )}
{/* TOAST */}

      {toast && (

        <Toast
          message={
            toast.message
          }
          type={
            toast.type
          }
          onClose={() =>
            setToast(null)
          }
        />

      )}

</div>

);

}